<template>
    <div class="addDevice">
      <!-- <h1>Add device</h1> -->
      <v-snackbar v-model="snackbar" :timeout="6000" :color="snackbar_color" location="top" max-height="10cm" max-width="5cm"  multi-line>                  
          {{ snackbar_text }}          
      </v-snackbar>
      <!-- <a @click="$router.go(-1)">back</a> -->
      <v-card variant="elevated" max-width="1500" style="margin:auto">
        <v-card-actions>
          <v-btn left>Add device</v-btn>
          <v-spacer />
          <v-btn color="red" right @click="$router.go(-1)">CLOSE</v-btn>
        </v-card-actions>
        <v-form v-model="form" @submit.prevent="onSubmit">
        <v-container>
          <v-row>
            <v-col cols="12">            
                <!-- <v-text-field :readonly="loading" :rules="[required]" clearable placeholder="1850024134" label="Device SN*" @change="checkDevice" v-model="device_data.f_deviceSN" ></v-text-field> -->
                <v-text-field :readonly="loading" :rules="[required]" clearable placeholder="1850024134" label="Device SN*" @change="checkDevice(device_data.f_deviceSN)" v-model="device_data.f_deviceSN" ></v-text-field>
            </v-col>

            <v-col cols="12">                                 
                <!-- <v-select
                          :items= "merchants"
                          item-title="merchantName"
                          item-value="merchantId"
                          label="Select Merchant*" 
                          v-model="device_data.f_merchantId"                         
                          :rules="[required]"                          
                ></v-select> --> 
                <!-- <v-autocomplete
                  clearable
                  :items= "merchants"
                  item-title="merchantName"
                  item-value="merchantId"
                  label="Select Merchant*" 
                  v-model="device_data.f_merchantId"                         
                  :rules="[required]"
                ></v-autocomplete>  --> 
                
                <v-autocomplete
                    v-model="device_data.f_merchantId"
                    :items="merchants" 
                    item-title="merchantName"
                    item-value="merchantId"
                    label="Select Merchant*" 
                    v-model:search="search"
                    placeholder="Start typing..."
                    hide-no-data
                    hide-selected                       
                    no-filter
                    required
                        
                        >                         
                </v-autocomplete>

            </v-col>

            <v-divider></v-divider>
            <v-col cols="12"> 

              <p>Merchant details</p>
              <v-row class="form-group" v-for="(input, k) in device_data.f_merchantDetails" :key="k">

                <v-col cols="2">            
                    <v-text-field :readonly="loading" :rules="[required]" clearable label="TID*" required v-model="input.tid"></v-text-field>
                </v-col>
                <v-col cols="3">            
                    <v-text-field :readonly="loading" :rules="[required]" clearable label="MID*" required v-model="input.mid"></v-text-field>
                </v-col>
                <v-col cols="2">                                 
                    <v-select
                              :items= "currencies"
                              item-title="currencyName"
                              item-value="currencyCode"
                              label="Select Currency*" 
                              v-model="input.currencyCode"                        
                              :rules="[required]"                          
                    ></v-select>                                              
                </v-col>
                <v-col cols="2">            
                    <v-text-field :readonly="loading" :rules="[required]" clearable label="CVM limit*" required v-model="input.cvm"></v-text-field>
                </v-col>
                <v-col cols="1">                           
                  <v-btn color="success" icon="mdi-plus" @click="add()" v-show="k == device_data.f_merchantDetails.length - 1"></v-btn> 
                </v-col>
                <v-col cols="1">                             
                  <v-btn color="red" icon="mdi-minus" @click="remove(k)" v-show="k || (!k && device_data.f_merchantDetails.length > 1)"></v-btn>
                   
                </v-col>

              </v-row>

            </v-col> 
            <v-divider></v-divider>
            <v-col cols="12">                                 
                        <!-- <v-autocomplete
                          :items="operations"
                          item-title="operationName"
                          item-value="operationId"
                          label="Select Operation*"
                          multiple
                          v-model="device_data.f_operationList"
                          :rules="[required]"
                        ></v-autocomplete> -->
                <p>Select Operation</p>         
                <!-- <p>{{ device_data.f_operationList }}</p> -->
                <!-- <v-row>        
                <v-checkbox
                  v-for="it in operations"
                  :key="it.operationId"
                  v-model="device_data.f_operationList"
                  :label="it.operationName"
                  :value="it.operationId"
                ></v-checkbox> 
                </v-row>  -->

                <v-row>
                  <v-col lg="3" 
                    v-for="it in operations"
                    :key="it.operationId">
                    <v-checkbox
                      v-model="device_data.f_operationList"
                      :label="it.operationName"
                      :value="it.operationName">
                    </v-checkbox>
                  </v-col>
                </v-row>
                
                
            </v-col>
            <v-divider></v-divider>
            <v-col cols="12"><p>Settelement Config</p></v-col>

            <!-- <v-col cols="12">                                 
                <v-text-field :readonly="loading" :rules="[required]" clearable label="Settlement name*" v-model="device_data.f_settlement.name"></v-text-field>                                              
            </v-col> -->
            <!-- <v-col cols="6">                                 
                <v-select
                  :items= "['true', 'false']"                          
                  label="Select Status*"                          
                  :rules="[required]" 
                  v-model="device_data.f_settlement.status"                         
                ></v-select>                                              
            </v-col> -->
            <!-- <v-col cols="6">                                 
              <v-text-field :readonly="loading" :rules="[required]" label="Settlement time*" v-model="device_data.f_settlement.time" type="time" suffix="PST" ></v-text-field>                                                
            </v-col> -->
            <v-col cols="6">                                 
              <v-text-field :readonly="loading" label="Settlement time*" v-model="device_data.f_stmTime" type="time" suffix="PST" ></v-text-field>                                                
            </v-col>

            <v-col cols="12">                                 
                <!-- <v-autocomplete
                    :items="days"
                    item-title="dayName"
                    item-value="dayId"
                    label="Select Settlement Days*"
                    multiple  
                    v-model="device_data.f_dayList" 
                    :rules="[required]"                       
                ></v-autocomplete> -->
                <p>Select Days</p>
                <v-row >
                  <v-col lg="3" 
                    v-for="it in days"
                    :key="it.dayId">
                    <v-checkbox
                      v-model="device_data.f_dayList"
                      :label="it.dayName"
                      :value="it.dayName">
                    </v-checkbox>
                  </v-col>
                </v-row>
            </v-col>

            <v-divider></v-divider>

            <v-col cols="3">            
                <v-text-field :readonly="loading" clearable label="Number of Receipt" required v-model="device_data.f_receiptNumber"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">                                 
              <v-select
                :items= "['true', 'false']"                          
                label="Dual Currency Status"                      
                v-model="device_data.f_isDualCurrency"
              ></v-select>                                              
            </v-col> 
            <v-col cols="12" sm="6">                                 
              <v-select
                :items= "['true', 'false']"                          
                label="Download Status"                      
                v-model="device_data.f_isDownloadEnable"
              ></v-select>                                              
            </v-col> 

            <v-divider></v-divider>

          </v-row> 
          
          <v-row><small>* indicates required field</small></v-row>
           
          <v-row justify="center">
            <v-col cols="auto">
              <v-btn :disabled="!form" :loading="loading" color="success" type="submit" @click="addDevice">SUBMIT</v-btn>
            </v-col>

            <v-col cols="auto">
              <v-btn @click="this.$router.push({name:'DeviceDetails'})">Cancel</v-btn>
            </v-col>            
          </v-row>
          
           
        </v-container>  
        
        </v-form>
        
        
      </v-card>
    
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  export default {
    name: 'Role',
    props: {
      msg: String      
    },
    data(){
      return {
        name: '',       
        devices: [],  
        merchants:[],
        operations: [],
        days: [{dayId: "Monday", dayName: "Monday"}, {dayId: "Tuesday", dayName: "Tuesday"}, {dayId: "Wednesday", dayName: "Wednesday"}, {dayId: "Thursday", dayName: "Thursday"}, {dayId: "Friday", dayName: "Friday"}, {dayId: "Saturday", dayName: "Saturday"}, {dayId: "Sunday", dayName: "Sunday"}],
        currencies: [],  
        
        dialog: false,
        dialog_update: false,
        dialog_delete: false,

        device_data:{  
          f_deviceSN: '',
          f_merchantId: '',
          f_merchantDetails: [{tid: '', mid: '', cvm: '', currencyId: ''}],
          f_operationList: [],
          /* f_settlement : {
            name: '',
            status: '',
            time: ''
          }, */
          f_dateCreated: '',
          f_dayList: [],
          f_stmTime: '',
          f_createByUserEmail: '',
          f_dateUpdated: '',
          f_updatedByUserEmail: '',
          f_receiptNumber: 2,
          f_isDualCurrency: false,
          f_isDownloadEnable: true,
          
        },

        deviceId: '',           
        
        inputs:[  //not in use
          {tid: '', mid: '', cvm: ''}
        ],

        //form
        form: false,
        loading: false,
        exist: false,

        
        //snackbar
        snackbar: false,
        snackbar_text: '',
        snackbar_color: '',

        


      }
    },

    created () {
      
    },

    watch:{
        

        //auto-complete
        search(newSearch) {
          if (newSearch.length >= 2) {
            this.searchMerchant(newSearch);
          } else {
            this.merchants = [];
          }
        },
        
    },

    methods:{

      onSubmit () {
        //if (!this.form) return
        //this.loading = true
        //setTimeout(() => (this.loading = false), 2000)
        //this.addDevice
      },

      required (v) {
        return !!v || 'Field is required'
      },

      device_check(v) {                
          this.checkDevice(v)
          if(this.exist) return true
          return 'Device exist'
      },

      add(){
          //this.inputs.push({name: ''});
          this.device_data.f_merchantDetails.push({tid: '', mid: '', cvm: '', currencyId: ''});          
      },

      remove(index){
         // this.inputs.splice(index, 1);
          this.device_data.f_merchantDetails.splice(index, 1);
      },

      show_toast(status, color, text){
        this.snackbar = status
        this.snackbar_color = color
        this.snackbar_text = text;
      },

      requests_handler() {        
        
        axios.all([       
            /* axios.get(window.baseurl+""+"merchants/org/"+this.orgId , 
              {"headers": {'Authorization': 'Bearer ' + this.$cookies.get("accessToken")}}
            ), */
            axios.get(window.baseurl+""+"currencies" , 
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
            ),
            axios.get(window.baseurl+""+"operations/org/"+this.orgId , 
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
            ),
            /* axios.get(window.baseurl+""+"sDays/list" , 
              {"headers": {'Authorization': 'Bearer ' + this.$cookies.get("accessToken")}}
            ) */
            
        ])
        .then(axios.spread((cur_response, ope_response) => {             
              //console.log("data1", mer_response.data)
              // console.log("data2", cur_response.data)
              // console.log("data3", ope_response.data)
              //console.log("data4", days_response.data)
              // console.log("data10", this.user_org)

              
              /* if(mer_response.status == 200){  
                  if(mer_response.data.records != null && mer_response.data.records.length > 0){
                      let i = 0;
                      this.merchants = [];   //remove all items from array
                      for(i=0; i<mer_response.data.records.length; i++){   
                         let merchant_name =   mer_response.data.records[i].merchantName + " - "+ mer_response.data.records[i].merchantAddress;                                               
                          //this.merchants.push({ merchantId: mer_response.data[i].merchantId, merchantName: mer_response.data[i].merchantName }); 
                          this.merchants.push({ merchantId: mer_response.data.records[i].id, merchantName: merchant_name });                          
                          console.log("merchants", this.merchants)
                         
                      }                      
                  }                  
              }  */
              
              if(cur_response.status == 200){  
                  if(cur_response.data != null && cur_response.data.length > 0){
                      let i = 0;
                      this.currencies = [];   //remove all items from array
                      for(i=0; i<cur_response.data.length; i++){                                                    
                          this.currencies.push({ currencyCode: cur_response.data.records[i].currencyCode, currencyName: cur_response.data.records[i].currencyName });                          
                          //console.log("Currencies", this.currencies)
                         
                      }                      
                  }                  
              }  

              if(ope_response.status == 200){  
                  if(ope_response.data.records != null && ope_response.data.records.length > 0){
                      let i = 0;
                      this.operations = [];   //remove all items from array
                      for(i=0; i<ope_response.data.records.length; i++){                                                    
                          this.operations.push({ operationId: ope_response.data.records[i].id, operationName: ope_response.data.records[i].operationName });                          
                          //console.log("operations", this.operations)
                         
                      }                      
                  }                  
              } 
              
              
                        
        }))

      }, //end of requests_handler method

      //check device
      async checkDevice(sn){ 
        
            this.exist = false;
            //console.log("DEVICE SN", this.device_data.f_deviceSN)
            // console.log("DEVICE SN", sn)

            try {
              //let result_SN = await axios.get(window.baseurl+""+"device/get/"+""+this.device_data.f_deviceSN+""+"/serial_number")
              let result_SN = await axios.get(window.baseurl+""+"devices/sn/" +sn , 
                {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
              )
              //  console.log("RESPONSE", result_SN)
              if (result_SN.status == 200) {
                //alert("device exist");
                //this.show_toast(true, "warning", "Device exist");
                this.$root.vtoast.showError({message: sn + " Already exist"})
                // console.log("EXIST", "device exist")
                this.exist = true;
                //console.log("EXIST value 1", this.exist)
              }   
            }
            catch (err) {
              // console.log("EXIST", "device does not exist")
              // console.log(err.response.data);
              // if(err.response.data.message == "No value present" && err.response.data.status == 500){
              //   this.exist = false;
              //   console.log("EXIST value 2", this.exist)
              // }
              
            }
        
      },

      async addDevice(){
          //console.log("existing device", this.existing_deviceSN);
          // console.log("device SN  in form", this.device_data.f_deviceSN);

          /* //check if device exist in database before submitting data
          
            
            try {
              let result_SN = await axios.get(window.baseurl+""+"device/get/"+""+this.device_data.f_deviceSN+""+"/serial_number" , 
                {"headers": {'Authorization': 'Bearer ' + this.$cookies.get("accessToken")}}
               )
               console.log("RESPONSE", result_SN)
              if (result_SN.status == 200) {
                //alert("device exist");
                this.show_toast(true, "warning", "Device exist");
                console.log("EXIST", "device exist")
                this.exist = true;
                console.log("EXIST value 1", this.exist)
              }   
            }
            catch (err) {
              console.log("EXIST", "device does exist")
              console.log(err.response.data);
              if(err.response.data.message == "No value present" && err.response.data.status == 500){
                this.exist = false;
                console.log("EXIST value 2", this.exist)
              }
            } 
           */

          //this.checkDevice();
          if(this.exist){
            //console.log("EXIST112", this.exist);
            //alert("device exist");
            //this.show_toast(true, "warning", "Device exist"); 
            this.$root.vtoast.showError({message: "Device exist"})           
          }
          else{
            // console.log("EXIST113", this.exist)
            // console.log("form data2", this.device_data)
            try {
                let result = await axios.post(window.baseurl+"devices", {
                deviceSN:this.device_data.f_deviceSN,
                merchant_id:this.device_data.f_merchantId,
                merchantDetails:this.device_data.f_merchantDetails,
                //allowedOperations:this.device_data.f_operationList,
                allowedOperations:this.device_data.f_operationList.join(),
                
                stmTime:this.device_data.f_stmTime,
                //settleDays:this.device_data.f_dayList,
                settleDays:this.device_data.f_dayList.join(),
                receiptNumber:this.device_data.f_receiptNumber,
                dualCurrency:this.device_data.f_isDualCurrency,
                downloadEnable:this.device_data.f_isDownloadEnable,
                createdBy:this.userEmail,
                updatedBy:this.userEmail,                                       
                    
              },
              {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
              );          
              if (result.status == 201) {
                  //alert("successfull"); 
                  //this.show_toast(true, "success", "Successful");
                  this.$root.vtoast.show({message: result.data.message})
                  window.setInterval(() => {                   
                    //this.$router.push({name:'Devices'})
                    this.$router.go(-1)                  
                  }, this.waiting_time)           
                  
              }
            }catch (error) {              
              //console.log(error.response.data);
              //alert(err.response.data.message);
              //this.show_toast(true, "warning", err.message);
              this.$root.vtoast.showError({message: error.response.data.message})
            }
          }
            

      },


      async searchMerchant(search) {    
        // console.log("in searchMerchant", search);
        let result;

        this.mcc = [];
        //this.loading = true;
        //let page2 = this.page - 1;
        if (search.length < 2) {
          this.merchants = [];
          return;
        } 
        try{
          if(this.global_permissions.includes("ROLE_STAFF_ADMIN", "ROLE_STAFF_USER")){            
            result = await axios.get(window.baseurl+"merchants/search", {
              params: { search: search },
              headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
            })            
            // console.log("activity_search_object", result);
            this.merchants = result.data.records;  
            
          } 

          else if(this.global_permissions.includes("ROLE_USER_ADMIN", "ROLE_MOD_MERCHANT")){            
            result = await axios.get(window.baseurl+"merchants/org/search/" + this.orgId, {
              params: { search: search },
              headers: { 'Authorization': 'Bearer ' + this.accessToken  }            
            })            
            // console.log("activity_search_object", result);
            this.merchants = result.data.records;  
            
          } 
            
        } 
        catch (error){            
            this.show_toast(true, "warning", error.message);            
        }   
      },
   
      

    },
    

    async mounted(){

      this.checkTokenExpiry();
      
      this.requests_handler() 

    }

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  </style>
  